import { render, staticRenderFns } from "./TrackingRuleNotificationsRemove.vue?vue&type=template&id=961d1a02&scoped=true&"
import script from "./TrackingRuleNotificationsRemove.vue?vue&type=script&lang=js&"
export * from "./TrackingRuleNotificationsRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961d1a02",
  null
  
)

export default component.exports